var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAvatarGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2046_68787)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D5D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3073 40.0143C9.02368 39.9284 6.40614 36.6878 7.09667 33.5323L7.1196 33.4069C7.80718 29.6461 8.25819 26.5191 8.28443 22.1364C8.3353 13.6405 14.8919 9.1671 20.6003 9.16641C20.6003 9.16641 21.0138 9.16112 21.1954 9.16641C28.0285 9.3655 33.1107 14.6401 33.3853 22.512C33.4136 23.3237 33.4182 24.0977 33.3992 24.8359C33.4132 25.4281 33.4088 26.0574 33.3855 26.7262C33.1109 34.5981 29.0717 39.8727 22.2386 40.0718C21.1205 40.1044 19.5568 40.0733 17.2731 40.0414C14.9894 40.0095 14.2864 40.0447 12.3073 40.0143Z",
    fill: "#F5F7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7631 19.6211C20.8199 20.5734 19.2882 20.5761 18.3416 19.627",
    stroke: "#B9BBBE",
    strokeWidth: 1.212,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.891,
    cy: 16.9115,
    rx: 0.816983,
    ry: 0.85686,
    fill: "#B9BBBE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.2147,
    cy: 16.9115,
    rx: 0.816983,
    ry: 0.85686,
    fill: "#B9BBBE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.75,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2046_68787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatarGray);
export default __webpack_public_path__ + "static/media/default-avatar-gray.de2581a6ad80f6c5f46e4f73530272c7.svg";
export { ForwardRef as ReactComponent };